import PayStrategy from "./PayStrategy";

export default class PayGuestStrategy extends PayStrategy {
  calculateTotal() {
    if (this.isClientPaysFeeNull) {
      this.amount = this.amount * this.feePercentage + this.amount;
    } else {
      if (this.amount <= this.threshold) {
        this.amount += this.fixedFee;
      } else {
        this.amount =
          this.amount * this.percentageFeeAboveThreshold + this.amount;
      }
    }

    return Number(Math.round(`${this.amount}e${0}`) + "e-" + 0);
  }

  calculateFee() {
    let fee = 0
    if (this.isClientPaysFeeNull) {
      fee = this.amount * this.feePercentage;
    } else {
      fee =
      this.amount <= this.threshold
        ? this.fixedFee
        : this.amount * this.percentageFeeAboveThreshold;
    }
    
    return Number(Math.round(`${fee}e${0}`) + "e-" + 0);
  }
}
